module.exports = __webpack_public_path__ + "static/media/picto_oeil_veille_continuelle.98f492aa.svg";